export const state = {
    data: {
        totalVehicle: 0,
        geofence: {
            fenceName: null,
            polyData: null,
            circData: null,
            type: null,
            province: null,
            city: null,
            phoneNo: null,
            contactName: null,
            center: {
                latitude: null,
                longitude: null
            }
        },
        totalGroup: 0,
        vgroup: [],
    }
}

export const mutations = {
    SET_GEOFENCE(state, payload) {
        state.data = payload
    },
    SET_CALCULATED_MOTION_STATUS(state, payload) {
        state.data.vgroup[payload.indexVgroup].vehicles[payload.indexVehicle].calculatedMotionStatus = payload.calculatedMotionStatus
    }
}